// extracted by mini-css-extract-plugin
export default {"container":"starter_container__ZQ4TA","buttons":"starter_buttons__bPYkP","title":"starter_title__Mq2X6"};